/* Structural layout plus the same scoped token re-point as AuthTextInput —
   see AuthTextInput.module.css for why it lands on the component's own root.

   Astryx has no password reveal and TextInput has no end slot, so the toggle
   (a 28px ghost Button) is overlaid inside the input's border, where Astryx
   draws its own clear button. The accent re-point covers its focus ring. */

.wrapper {
  position: relative;
  --color-accent: var(--color-text-primary);
}

/* Reserve the toggle's width plus the input's usual gap, so typed text never
   runs under it. StyleX compiles TextInput's padding with boosted specificity
   (`:not(#\#)` chains), so a class can only win here with !important. */
.input {
  composes: field from "./AuthTextInput.module.css";
  padding-inline-end: calc(var(--spacing-0-5) + var(--size-element-sm) + var(--spacing-2)) !important;
}

/* Anchored to the input row rather than centred in the whole field, so a
   detached error message below doesn't pull it down. The offset puts the
   glyph where the clear button's would sit. The input wrapper is z-index 1. */
.toggle {
  position: absolute;
  top: 0;
  right: calc(var(--border-width) + var(--spacing-0-5));
  z-index: 2;
  height: var(--size-element-md);
  display: flex;
  align-items: center;
}
